// extracted by mini-css-extract-plugin
export default {"about":"about_about__I+Fzb","title":"about_title__-HFjc","text":"about_text__nWF88"};